import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.lumiereaesthetics.com.au";
const SITE_SUFFIX = "Lumière Aesthetics Cottesloe";
const DEFAULT_TITLE = "Lumière Aesthetics Cottesloe | Doctor-Run Aesthetics, Perth";
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-card.jpg`;

// Every title carries the location, max 60 chars. If the page name is long,
// the suffix shortens rather than the name breaking mid-word.
const normalizeTitle = (t) => {
  if (!t) return DEFAULT_TITLE;
  if (t.startsWith(SITE_SUFFIX)) return t;
  const base = t.replace(/\s*\|\s*Lumière Aesthetics.*$/, "").trim();
  const full = `${base} | ${SITE_SUFFIX}`;
  if (full.length <= 60) return full;
  return `${base} | Lumière Cottesloe`;
};

const truncateDescription = (d) => {
  if (!d || d.length <= 155) return d;
  const cut = d.slice(0, 152);
  return `${cut.slice(0, cut.lastIndexOf(" "))}…`;
};

const SEO = ({ title, description, jsonLd, ogImage, ogTitle, noindex = false }) => {
  const { pathname } = useLocation();
  const canonical = SITE_URL + (pathname === "/" ? "/" : pathname.replace(/\/$/, ""));
  const fullTitle = normalizeTitle(title);
  const desc = truncateDescription(description);
  const image = ogImage
    ? ogImage.startsWith("http") ? ogImage : `${SITE_URL}${ogImage}`
    : DEFAULT_OG_IMAGE;
  return (
    <>
      <title>{fullTitle}</title>
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {desc && <meta name="description" content={desc} />}
      <meta property="og:title" content={ogTitle || fullTitle} />
      {desc && <meta property="og:description" content={desc} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <link rel="canonical" href={canonical} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </>
  );
};

export default SEO;
